import React from 'react';
import { useAppDispatch } from '../app/redux/useAppSelector';
import { MenuItem, MenuSeparator } from '../components/Menu';
import arrowDown from '../icons/non-prefilled/16x16/arrowDown.svg';
import arrowUp from '../icons/non-prefilled/16x16/arrowUp.svg';
import editIcon from '../icons/non-prefilled/16x16/edit.svg';
import { UIActions } from '../ui/uiSlice';
import useCanManageSidebarSections from './useCanManageSidebarSections';

interface ManageSectionsMenuItemProps {
  selectedSectionId: string;
  onMoveSectionUp?: () => void;
  onMoveSectionDown?: () => void;
}

const SidebarSectionOverflowMenuItems = ({
  selectedSectionId,
  onMoveSectionUp,
  onMoveSectionDown,
}: ManageSectionsMenuItemProps) => {
  const dispatch = useAppDispatch();
  const canManageSidebarSections = useCanManageSidebarSections();

  return (
    <>
      <MenuItem
        icon={arrowUp}
        disabled={!onMoveSectionUp}
        onClick={onMoveSectionUp}
      >
        Move up
      </MenuItem>
      <MenuItem
        icon={arrowDown}
        disabled={!onMoveSectionDown}
        onClick={onMoveSectionDown}
      >
        Move down
      </MenuItem>

      {canManageSidebarSections && (
        <>
          <MenuSeparator />
          <MenuItem
            icon={editIcon}
            onClick={() =>
              dispatch(UIActions.setSelectedSectionId(selectedSectionId))
            }
          >
            Manage sections
          </MenuItem>
        </>
      )}
    </>
  );
};

export default SidebarSectionOverflowMenuItems;
